import { TeamState } from '../types/team'

export const initialTeamState: TeamState = {
  teams: [],
  isLoading: false,
  error: null,
}
